import{z as i}from"zod";const s=i.preprocess(r=>typeof r=="string"?r.trim().replaceAll(/\s+/g," "):r,i.string().min(1)),n=i.preprocess(r=>typeof r=="string"?r.trim():r,i.string().min(1));export{s as Z,n as a};
